/**
 * 리스트에서 window.open으로 연 상세 탭을 닫는다.
 * 스크립트로 열지 않은 탭이거나 브라우저 정책상 실패해도 예외 없이 조용히 끝난다.
 */
export const closeCurrentTab = () => {
  window.close()
}
